import React from 'react'
import classNames from 'classnames'
import { MagentoProductPrices } from 'lib/types'
import { Price, productHasSpecialPrice } from 'lib/shared'

interface Props {
  extraPrice?: number
  quantity?: number
  renderOldPrice?: boolean
  price: MagentoProductPrices
}

export const Default = ({
  extraPrice = 0,
  price,
  quantity = 1,
  renderOldPrice = false
}: Props) => {
  const { regularPrice, maximalPrice } = price
  const { amount: amountRegular } = regularPrice
  const { amount: amountMaximal } = maximalPrice
  const { value: valueRegular, currency } = amountRegular
  const { value: valueMaximal } = amountMaximal
  const hasSpecialPrice = productHasSpecialPrice(price)
  const shouldRenderOldPrice = (renderOldPrice && hasSpecialPrice) || !hasSpecialPrice

  if (!valueRegular || !currency) {
    return null
  }

  return (
    <>
      {shouldRenderOldPrice && (
        <span
          className={classNames({
            regularPrice: !hasSpecialPrice,
            oldPrice: hasSpecialPrice
          })}
        >
          <Price
            value={(valueRegular + extraPrice) * quantity}
            currency={currency}
          />
        </span>
      )}
      {hasSpecialPrice && (
        <span
          className='specialPrice'
        >
          <Price
            value={(valueMaximal + extraPrice) * quantity}
            currency={currency}
          />
        </span>
      )}
    </>
  )
}
